import { createApp } from 'vue';
import Message from '../components/Message.vue';

const message = {
  install(app) {
    const messageInstance = (options) => {
      const container = document.createElement('div');
      document.body.appendChild(container);

      const instance = createApp(Message, {
        ...options,
        onClose: () => {
          instance.unmount();
          document.body.removeChild(container);
        }
      });

      instance.mount(container);
    };

    app.config.globalProperties.$message = {
      success(content, duration) {
        messageInstance({
          content,
          type: 'success',
          duration
        });
      },
      warning(content, duration) {
        messageInstance({
          content,
          type: 'warning',
          duration
        });
      },
      info(content, duration) {
        messageInstance({
          content,
          type: 'info',
          duration
        });
      },
      error(content, duration) {
        messageInstance({
          content,
          type: 'error',
          duration
        });
      }
    };
  }
};

export default message; 